import type { CircleFormat } from '@leanin/shared/circle-format';

// Display keys for the canonical Circle formats (`@leanin/shared/circle-format`,
// the same values the API, the `format` query param and filter state use).
// Display strings are derived at render from these keys (i18n, `Circles`
// namespace) for the directory chrome, the list body and the card facts.
export const CIRCLE_FORMAT_LABEL_KEY = {
  in_person: 'chrome.formatInPerson',
  virtual: 'chrome.formatVirtual',
  hybrid: 'chrome.formatHybrid',
} as const satisfies Record<CircleFormat, string>;
